<template>
  <v-row row wrap>

    <v-col cols="12">
      <v-row justify="space-between">
        <v-col cols="12" sm="6" md="8">
          <!-- FILTERS HERE -->
        </v-col>
        <v-col cols="12" sm="6" md="4">
          <search-input @search="performSearch" v-model="search"/>
        </v-col>
      </v-row>
    </v-col>

    <v-col cols="12">

      <v-data-table dense
                    class="mt-3"
                    :headers="headers"
                    :items="items"
                    :search="search"
                    :single-expand="false"
                    :server-items-length="totalItems"
                    :loading="loading"
                    :page.sync="pageNumber"
                    :items-per-page.sync="itemsPerPage"
                    :sort-by.sync="orderBy"
                    :sort-desc.sync="orderDesc"
                    :footer-props="{ itemsPerPageOptions: [5, 10, 25, 50] }"
                    @update:page="fetch"
                    @update:sort-by="fetch"
                    @update:sort-desc="fetch"
                    @update:items-per-page="fetch"
      >


        <template v-slot:item.Estado="{item}">
          <span :class="getEstadoColor(item.Estado)">{{ item.Estado }}</span>
        </template>

        <template v-slot:item.CbteTipo="{item}">
          {{ getTipoComprobante(item.CbteTipo) }}
        </template>

        <template v-slot:item.CbteFch="{item}">
          {{ getDateFormat(item.CbteFch) }}
        </template>

        <template v-slot:item.Concepto="{item}">
          {{ getTipoConcepto(item.Concepto) }}
        </template>

        <template v-slot:item.Importe="{item}">
          ${{ item.ImpTotal }} (<span class="green--text text--darken-2">{{ item.ImpNeto }}</span>/<span
            class="red--text text--darken-2">{{ item.ImpIVA }}</span>)
        </template>

        <template slot="no-data">
          <div class="text-xs-center" v-t="'common.noData'"></div>
        </template>

        <template slot="loading">
          <div class="text-xs-center" v-t="'common.loading'"></div>
        </template>

        <template v-slot:item.facturar="{item}">


          <v-btn small icon text
                 @click="facturar(item.id)"
                 color="teal"
                 :disabled="!!item.CAE"
          >
            <v-icon>task_alt</v-icon>
          </v-btn>
        </template>

        <template v-slot:item.action="{ item }">

          <show-button @click="$emit('show', item)"/>
          <edit-button v-if="item.Estado != 'FACTURADO' && $store.getters.hasPermission('FACTURA_UPDATE')"
                       @click="$emit('update', item)"/>
          <delete-button v-if="item.Estado != 'FACTURADO' && $store.getters.hasPermission('FACTURA_DELETE')"
                         @click="$emit('delete', item)"/>
        </template>

      </v-data-table>
    </v-col>

    <v-snackbar color="red white--text" v-model="showErrorFactura">
      {{errorFactura}}
    </v-snackbar>
  </v-row>
</template>

<script>
import FacturaProvider from "../../../../providers/FacturaProvider";

import {DeleteButton, EditButton, ShowButton, SearchInput} from "@dracul/common-frontend"
import AfipProvider from "@/modules/afip/providers/AfipProvider";
import {DayjsMixin} from "@dracul/dayjs-frontend"

export default {
  name: "FacturaList",
  components: {DeleteButton, EditButton, ShowButton, SearchInput},
  mixins: [DayjsMixin],
  data() {
    return {
      factura: null,
      items: [],
      totalItems: null,
      loading: false,
      orderBy: null,
      orderDesc: false,
      itemsPerPage: 5,
      pageNumber: 1,
      search: '',
      filters: [
        /*{
            field: '',
            operator: 'eq', //(eq|contain|regex|gt|lt|lte|gte)
            value: ''
        }*/
      ],
      serverStatus: null,
      puntosVenta: [],
      tiposComprobantes: [],
      tiposConceptos: [],
      tiposDocumentos: [],
      showErrorFactura: false,
      errorFactura: null
    }
  },
  computed: {
    getEstadoColor() {
      return estado => {
        switch (estado) {
          case 'PENDIENTE':
            return 'purple--text text--darken-2'
          case 'ERROR':
            return 'red--text text--darken-2'
          case 'FACTURADO':
            return 'green--text text--darken-2'
          default:
            return 'grey--text text--darken-2'
        }
      }
    },
    getTipoComprobante() {
      return val => {
        let item = this.tiposComprobantes.find(i => i.Id === val)
        return item ? item.Desc : val
      }
    },
    getTipoConcepto() {
      return val => {
        let item = this.tiposConceptos.find(i => i.Id === val)
        return item ? item.Desc : val
      }
    },
    headers() {
      return [
        //Entity Headers
        {text: this.$t('afip.factura.labels.Estado'), value: 'Estado'},
        // {text: this.$t('afip.factura.labels.CantReg'), value: 'CantReg'},
        {text: this.$t('afip.factura.labels.PtoVta'), value: 'PtoVta'},
        {text: this.$t('afip.factura.labels.CbteTipo'), value: 'CbteTipo'},
        {text: this.$t('afip.factura.labels.Concepto'), value: 'Concepto'},
        //{text: this.$t('afip.factura.labels.DocTipo'), value: 'DocTipo'},
        //{text: this.$t('afip.factura.labels.DocNro'), value: 'DocNro'},
        //  {text: this.$t('afip.factura.labels.CbteDesde'), value: 'CbteDesde'},
        // {text: this.$t('afip.factura.labels.CbteHasta'), value: 'CbteHasta'},
        {text: this.$t('afip.factura.labels.CbteFch'), value: 'CbteFch'},
        {text: this.$t('afip.factura.labels.Importe'), value: 'Importe', width: '160px'},
        // {text: this.$t('afip.factura.labels.ImpTotal'), value: 'ImpTotal'},
        //{text: this.$t('afip.factura.labels.ImpTotConc'), value: 'ImpTotConc'},
        // {text: this.$t('afip.factura.labels.ImpNeto'), value: 'ImpNeto'},
        //{text: this.$t('afip.factura.labels.ImpOpEx'), value: 'ImpOpEx'},
        // {text: this.$t('afip.factura.labels.ImpIVA'), value: 'ImpIVA'},
        //{text: this.$t('afip.factura.labels.ImpTrib'), value: 'ImpTrib'},
        //{text: this.$t('afip.factura.labels.MonId'), value: 'MonId'},
        //{text: this.$t('afip.factura.labels.MonCotiz'), value: 'MonCotiz'},
        {text: this.$t('afip.factura.labels.CAE'), value: 'CAE'},
        //{text: this.$t('afip.factura.labels.CAEFchVto'), value: 'CAEFchVto'},
        //Actions
        {text: this.$t('afip.factura.labels.facturar'), value: 'facturar', sortable: false},
        {text: this.$t('common.actions'), value: 'action', sortable: false},
      ]
    },
    getOrderBy() {
      return (Array.isArray(this.orderBy)) ? this.orderBy[0] : this.orderBy
    },
    getOrderDesc() {
      return (Array.isArray(this.orderDesc)) ? this.orderDesc[0] : this.orderDesc
    }
  },
  async created() {
    //await this.getPuntosVenta()
    await this.getTipoComprobantes()
    await this.getTipoConceptos()
    // await this.getTipoDocumentos()
    this.fetch()
  },
  methods: {
    performSearch() {
      this.pageNumber = 1
      this.fetch()
    },
    facturar(facturaId) {
      AfipProvider.createElectronicBilling(facturaId)
          .then(r => {
            this.factura = r.data.createElectronicBilling
          })
          .catch(e => {
            console.log(e)
            this.errorFactura = e.message
            this.showErrorFactura = true
          })
          .finally(()=>{
            this.fetch()
          })
    },
    fetch() {
      this.loading = true
      FacturaProvider.paginateFactura(
          this.pageNumber,
          this.itemsPerPage,
          this.search,
          this.filters,
          this.getOrderBy,
          this.getOrderDesc
      ).then(r => {
        this.items = r.data.paginateFactura.items
        this.totalItems = r.data.paginateFactura.totalItems
      }).catch(err => {
        console.error(err)
      }).finally(() => this.loading = false)
    },
    getServerStatus() {
      AfipProvider.getServerStatus()
          .then(r => {
            this.serverStatus = r.data.getServerStatus
          })
    },
    getPuntosVenta() {
      AfipProvider.getPuntosVenta()
          .then(r => {
            this.puntosVenta = r.data.getPuntosVenta ? r.data.getPuntosVenta : []
          })
    },
    getTipoComprobantes() {
      AfipProvider.getTipoComprobantes()
          .then(r => {
            this.tiposComprobantes = r.data.getTipoComprobantes ? r.data.getTipoComprobantes : []
          })
    },
    getTipoConceptos() {
      AfipProvider.getTipoConceptos()
          .then(r => {
            this.tiposConceptos = r.data.getTipoConceptos ? r.data.getTipoConceptos : []
          })
    },
    getTipoDocumentos() {
      AfipProvider.getTipoDocumentos()
          .then(r => {
            this.tiposDocumentos = r.data.getTipoDocumentos ? r.data.getTipoDocumentos : []
          })
    }
  }

}
</script>


